var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showElement)?_c('span',{staticClass:"notification"},[_vm._v(" "+_vm._s(_vm.unreadNotifications)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }